import React, { Component } from "react";
import PropTypes from "prop-types";
import "./Default.css";

const propTypes = {
  children: PropTypes.node,
};

const defaultProps = {};

class DefaultFooter extends Component {
  render() {
    // eslint-disable-next-line
    const { children, ...attributes } = this.props;

    return (
      <React.Fragment>
        <div>
          <div
            style={{
              marginLeft: "10px",
              padding: "10px",
              textAlign: "center",
              width: "100%",
              marginLeft: "120px",
            }}
          >
            <span
              style={{
                fontSize: "12px",
                fontWeight: "500",
                opacity: "0.6",
                color: "#ffffff",
              }}
            >
              Copyright © {new Date().getFullYear()} by SmarterHomes Private
              Ltd. All Rights Reserved. {process.env.REACT_APP_VERSION}
            </span>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

DefaultFooter.propTypes = propTypes;
DefaultFooter.defaultProps = defaultProps;

export default DefaultFooter;
